import { render } from "./UpdateKeyFigures.vue?vue&type=template&id=f3b4fde0&scoped=true&ts=true"
import script from "./UpdateKeyFigures.vue?vue&type=script&lang=ts"
export * from "./UpdateKeyFigures.vue?vue&type=script&lang=ts"

import "./UpdateKeyFigures.vue?vue&type=style&index=0&id=f3b4fde0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3b4fde0"]])

export default __exports__